import React, { FC, Fragment } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { useRightContentSpacing } from '~/hooks/styles';
import { AsideBase } from '~/layout';
import { TextField, StatusField, H3 } from '~/components';
import { time } from '~/utils';
import { useTranslate } from 'react-admin';
import { Transfer } from '~/types/Transfer';
import { TimeIcon } from '~/img';
import OperationTypeField from '~/components/OperationTypeField';
import InfoIcon from '@material-ui/icons/Info';
import { isEmpty } from 'lodash';
import WarningIcon from '@material-ui/icons/Warning';
import ExploreIcon from '@material-ui/icons/Explore';

type Props = {
  record?: Transfer;
};

const RightPanel: FC<any> = (props: Props) => {
  const { record: transfer } = props;

  const translate = useTranslate();
  const t = (key: string, args?: any): string => translate(`resources.transfers.show.${key}`, args);

  const spacing = useRightContentSpacing();
  const classes = useStyles({ spacing });

  if (!transfer) {
    return null;
  }

  return (
    <Grid container item xs direction='column' spacing={spacing}>
      <Grid item className={classes.asideContent}>
        <AsideBase className={classes.root}>
          <Grid container spacing={2} className={classes.layout}>
            <Grid item xs={12}>
              <TextField label={t('postingDate')} icon={<TimeIcon />}>
                {/* only date no time */}
                {time(transfer?.postingDate).format('ll')}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField label={t('postedAt')} icon={<></>}>
                {time(transfer?.postedAt).format('ll, LTS')}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField label={t('transactionCreatedAt')} icon={<></>}>
                {transfer?.transactionCreatedAt &&
                  time(transfer?.transactionCreatedAt).format('ll, LTS')}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField label={t('transferOperationType')} icon={<InfoIcon />}>
                <OperationTypeField operationType={transfer?.transferOperationType} />
              </TextField>
            </Grid>
            {transfer?.ledgerMappingStatusBySystem &&
            !isEmpty(transfer?.ledgerMappingStatusBySystem) ? (
              <>
                <H3 icon={<WarningIcon />} style={{ marginLeft: 8 }}>
                  {t('ledgerMappingStatus')}
                </H3>
                {Object.entries(transfer?.ledgerMappingStatusBySystem).map(([system, status]) => (
                  <Fragment key={`${system}-${status}`}>
                    <Grid item xs={12} style={{ paddingLeft: 40 }}>
                      <TextField compact label={system}>
                        <StatusField status={status} />
                      </TextField>
                    </Grid>
                    {status === 'FAILED' && (
                      <>
                        {transfer?.details?.lastErrorMessage && (
                          <Grid item xs={12} style={{ paddingLeft: 40 }}>
                            <TextField
                              label={
                                t('lastError') +
                                (transfer?.details?.lastErrorTimestamp
                                  ? ' ' + time(transfer?.details?.lastErrorTimestamp).format('lll')
                                  : '')
                              }
                              multiline
                              compact
                            >
                              {transfer?.details?.lastErrorMessage}
                            </TextField>
                          </Grid>
                        )}
                      </>
                    )}
                  </Fragment>
                ))}
                {!isEmpty(transfer?.details?.referenceId) && (
                  <>
                    <Grid item xs={12}>
                      <TextField icon={<ExploreIcon />}>{t('referenceId')}</TextField>
                    </Grid>
                    {transfer.details.referenceId.map((referenceId: any, index: Number) => (
                      <Grid item xs={12} key={referenceId.name + index}>
                        <TextField label={referenceId.name} icon={<></>}>
                          {referenceId.value}
                        </TextField>
                      </Grid>
                    ))}
                  </>
                )}
              </>
            ) : null}
          </Grid>
        </AsideBase>
      </Grid>
    </Grid>
  );
};

type StylesPrpos = {
  spacing: number;
};

const useStyles = makeStyles<Theme, StylesPrpos>((theme) => ({
  asideContent: {
    marginLeft: ({ spacing }) => theme.spacing(spacing),
  },
}));

export default RightPanel;
